import { gql } from 'src/__generated__'

export default gql(`
  mutation removeCanteen($id: Int!) {
    removeCanteen(id: $id)
  }
`)
